export const PAYMENT_TYPE_SCHEDULED = 'schedulePayment';
export const PAYMENT_TYPE_UNSCHEDULED_PARTIAL = 'unscheduledPartialPayment';
export const PAYMENT_TYPE_UNSCHEDULED_PAID_OFF = 'unscheduledPayoffPayment';
export const PAYMENT_TYPE_DOWN_PAYMENT = 'downPayment';

export const unscheduledTypes = [
  PAYMENT_TYPE_UNSCHEDULED_PARTIAL,
  PAYMENT_TYPE_UNSCHEDULED_PAID_OFF,
];



// WEBPACK FOOTER //
// ./src/constants/paymentConstants.js